import Facing from '@components/shelfDetails/Facing'
import ShelfContainer from '@components/shelfDetails/ShelfContainer'
import ShelfSkeleton from '@components/shelfDetails/ShelfSkeleton'
import { useShelfHoverState } from '@components/shelfDetails/utils'
import { useProductsFromShelf } from '@state/product'
import { useShelf } from '@state/shelf/queries'
import { cx } from '@utils/cx.ts'

import type { FacingProducer } from './ShelfDetails'

interface ShelfProps {
    shelfId: string
    facingProducer?: FacingProducer
}

function SchematicViewShelf({ shelfId, facingProducer }: ShelfProps) {
  const { data: shelf, isLoading } = useShelf(shelfId)
  const { products: shelfProducts } = useProductsFromShelf(shelfId)
  const { hoverState, onPointerMove, onPointerLeave } = useShelfHoverState()

  if (isLoading || !shelf) return <ShelfSkeleton />

  const aspectRatio = shelf.width / shelf.height

  return (
    <ShelfContainer
      aspectRatio={aspectRatio}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
    >
      {
        shelf.layers.map(layer => (
          <div
            key={layer.id}
            data-testid={`shelf:layer:${layer.id}`}
            className='absolute'
            style={{
              bottom: `${layer.y * 100}%`,
              height: `${layer.height * 100}%`,
              width: '100%',
            }}
          >
            {layer.facings.map(facing => {
              const product = shelfProducts.find(p => p.gtin === facing.gtin)
              const state = !hoverState ? 'default' : hoverState === facing.id ? 'hovered' : 'dimmed'

              return (
                <Facing
                  key={facing.id}
                  className={cx(
                    'h-full border border-primary bg-utility-gray-100',
                    facingProducer?.({ viewType: 'schematic', facing, product, state })
                  )}
                  facing={facing}
                  product={product}
                  state={state}
                />
              )
            })}
          </div>
        ))
      }
    </ShelfContainer>
  )
}

export default SchematicViewShelf